/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { create } from 'zustand';

interface DmCallState {
  call: null | {
    conversationId: string;
    name: string;
  };
  openCall: (conversationId: string, name: string) => void;
  closeCall: () => void;
}

export const useDmCallStore = create<DmCallState>((set) => ({
  call: null,
  openCall: (conversationId, name) =>
    set({ call: { conversationId, name } }),
  closeCall: () => set({ call: null }),
}));